class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      checkCartAndAddItem();
      //this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

  //Upsell custom code
  
let productsToCheck = [
  { parent_id: 9643064951074, product_id: 9644530794786, variant_id: 49667943989538 }
];

  
async function checkCartAndAddItem() {
  $('button[name="add"][type="submit"]').attr('data-state', 'loading');
  console.log('Démarrage de checkCartAndAddItem');
  let itemDontExist = false;
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }
      return response.json();
    })
    .then(data => {
      console.log('Données reçues pour checkCartAndAddItem');
      productsToCheck.some(product_bundle => {
        const itemExists = data.items.some(item => item.product_id === product_bundle.parent_id);
        if (itemExists) {
          console.log(product_bundle.parent_id+' existe dans le panier');
          const equivalentExists = data.items.some(item => item.id === product_bundle.variant_id);
          if(product_bundle.product_id !== null){
            console.log('Upsell existe pour '+product_bundle.parent_id);
            if (!equivalentExists) {
              console.log(product_bundle.variant_id+' n\'existe pas dans le panier. Ajout en cours...');
              // Créer un nouvel élément FormData pour ajouter le produit équivalent
              let addToCartForm = new FormData();
              addToCartForm.append('quantity', '1');
              addToCartForm.append('form_type', 'product');
              addToCartForm.append('product-id', product_bundle.product_id);
              addToCartForm.append('id', product_bundle.variant_id);
  
              // Ajouter le produit équivalent au panier
              fetch('/cart/add.js', {
                method: 'POST',
                body: addToCartForm
              })
              .then(response => response.json())
              .then(data => {
                console.log(`Produit équivalent ajouté au panier: ${product_bundle.variant_id}`, data);
                countdownTimer(); 
                reloadPageContent();
              })
              .catch(error => {
                console.error(`Erreur lors de l'ajout du produit équivalent ${product_bundle.variant_id} au panier:`, error);
                countdownTimer(); 
                openCartDrawer();
              });
            } 
            else {
              countdownTimer(); 
              openCartDrawer();
              console.log('Response: Upsell exists in the cart.');
            }
          }
          else{
            openCartDrawer();
            console.log(`${product_bundle.parent_id} n'a aucun upsell configuré`, data);
          }
          itemDontExist = false;
          return true; // Sortir de la boucle `some()` si l'élément existe
        }
        else{
          itemDontExist = true;
        }
      });
      if(itemDontExist){
        openCartDrawer();
        countdownTimer();
      }
    })
    .catch(error => {
      console.error('Erreur lors de la récupération des données du panier:', error);
    });
}

async function checkCartAndAddItemForV6() {
  $('button[name="add"][type="submit"]').attr('data-state', 'loading');
  console.log('Démarrage de checkCartAndAddItem');
  let itemDontExist = false;
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }
      return response.json();
    })
    .then(data => {
      console.log('Données reçues pour checkCartAndAddItem');
      productsToCheck.some(product_bundle => {
        const itemExists = data.items.some(item => item.product_id === product_bundle.parent_id);
        if (itemExists) {
          console.log(product_bundle.parent_id+' existe dans le panier');
          const equivalentExists = data.items.some(item => item.id === product_bundle.variant_id);
          if(product_bundle.product_id !== null){
            console.log('Upsell existe pour '+product_bundle.parent_id);
            if (!equivalentExists) {
              console.log(product_bundle.variant_id+' n\'existe pas dans le panier. Ajout en cours...');
              // Créer un nouvel élément FormData pour ajouter le produit équivalent
              let addToCartForm = new FormData();
              addToCartForm.append('quantity', '1');
              addToCartForm.append('form_type', 'product');
              addToCartForm.append('product-id', product_bundle.product_id);
              addToCartForm.append('id', product_bundle.variant_id);
  
              // Ajouter le produit équivalent au panier
              fetch('/cart/add.js', {
                method: 'POST',
                body: addToCartForm
              })
              .then(response => response.json())
              .then(data => {
                console.log(`Produit équivalent ajouté au panier: ${product_bundle.variant_id}`, data);
                countdownTimer(); 
                reloadPageContent();
              })
              .catch(error => {
                console.error(`Erreur lors de l'ajout du produit équivalent ${product_bundle.variant_id} au panier:`, error);
                countdownTimer(); 
                reloadPageContent();
              });
            } 
            else {
              countdownTimer(); 
              reloadPageContent();
              console.log('Response: Upsell exists in the cart.');
            }
          }
          else{
            reloadPageContent();
            console.log(`${product_bundle.parent_id} n'a aucun upsell configuré`, data);
          }
          itemDontExist = false;
          return true; // Sortir de la boucle `some()` si l'élément existe
        }
        else{
          itemDontExist = true;
        }
      });
      if(itemDontExist){
        reloadPageContent();
        countdownTimer();
      }
    })
    .catch(error => {
      console.error('Erreur lors de la récupération des données du panier:', error);
    });
}

let isReloading = false; // Empêche les exécutions multiples

async function reloadPageContent() {
    if (isReloading) return;
    isReloading = true;

    fetch(window.location.href)
        .then(response => response.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Met à jour uniquement <cart-drawer> s'il existe
            const newCartDrawer = doc.querySelector('cart-drawer');
            const currentCartDrawer = document.querySelector('cart-drawer');

            if (newCartDrawer && currentCartDrawer) {
                currentCartDrawer.outerHTML = newCartDrawer.outerHTML;
            }

            // Met à jour uniquement le #cart-icon-bubble
            const newCartIcon = doc.querySelector("#cart-icon-bubble");
            const currentCartIcon = document.querySelector("#cart-icon-bubble");

            if (newCartIcon && currentCartIcon) {
                currentCartIcon.outerHTML = newCartIcon.outerHTML;
            }

            // Réattache les événements si nécessaires après mise à jour
            setTimeout(() => {
                if (document.querySelector("#cart-icon-bubble")) {
                    document.querySelector("#cart-icon-bubble").addEventListener("click", function (event) {
                        event.preventDefault();
                        openCartDrawer();
                    });
                }

                openCartDrawer();
                countdownTimer();
            }, 50);
        })
        .catch(error => console.error('Erreur de rechargement du panier :', error))
        .finally(() => setTimeout(() => isReloading = false, 500));
}

function updateBodyOverflow() {
    const body = document.querySelector("body");
    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer && cartDrawer.classList.contains("active")) {
        body.style.setProperty('overflow', 'hidden', 'important');
        body.style.setProperty('height', '100vh', 'important');
    } else {
        body.style.removeProperty('overflow');
        body.style.removeProperty('height');
    }
}

function observeCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer) {
        const observer = new MutationObserver(() => {
            updateBodyOverflow();
        });

        observer.observe(cartDrawer, { attributes: true, attributeFilter: ["class"] });
    }
}

function openCartDrawer() {
    console.log('Opening the cart drawer.');
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
        $('button[name="add"][type="submit"]').attr('data-state', 'idle');
        cartDrawer.open();
        /*
        const upsellIds = [1, 2, 3];
        executeUpsellsWithDelay(upsellIds, 500);
        insuranceUpsell();
        */
    } else {
        console.log('Cart drawer not found.');
    }
}


// Personnalize countdown
let countdownInterval; // Variable globale pour stocker l'ID de l'intervalle

function countdownTimer() {
  console.log('La fonction est chargée');
  const countdownElement = $('#counterTime');
  console.log('Element countdownElement:', countdownElement);

  // Vérifier si un intervalle est déjà en cours et l'empêcher de se relancer
  if (countdownInterval) {
    console.log('Un intervalle est déjà en cours, annulation du nouveau lancement');
    return;
  }

  // Récupération des données du panier via AJAX
  $.ajax({
    type: 'GET',
    url: '/cart.json',
    dataType: 'json',
    success: function(data) {
      console.log('Cart data received:', data);
      const cartItems = data.items;
      if (cartItems.length > 0) {
        const lastItem = cartItems[0];
        console.log('Last item in cart:', lastItem);
        
        // Récupération de la dernière valeur du produit dans le panier stockée en cookie
        const cookieLastProductId = Cookies.get('lastProductInCartId');
        console.log('Cookie last product ID:', cookieLastProductId);

        // Mise à jour de la valeur du cookie si le dernier produit dans le panier est différent de celui enregistré dans le cookie
        if (lastItem.variant_id !== parseInt(cookieLastProductId)) {
          Cookies.set('lastProductInCartId', lastItem.variant_id);
          Cookies.set('startTime', Math.floor(Date.now() / 1000));
          console.log('Updated cookies with new product ID and start time');
        }

        // Récupération du temps restant en fonction de l'heure actuelle et l'heure d'ajout du dernier produit stocké en cookie
        const startTime = Cookies.get('startTime');
        console.log('Start time from cookie:', startTime);
        if (startTime) {
          let remainingTime = 600 - (Math.floor(Date.now() / 1000) - parseInt(startTime));
          console.log('Initial remaining time:', remainingTime);

          // Affichage du temps restant dynamique chaque seconde
          countdownInterval = setInterval(() => {
            const minutes = Math.floor(remainingTime / 60);
            const seconds = remainingTime % 60;
            $('#counterTime').text(`${minutes}:${seconds < 10 ? '0' : ''}${seconds}`);
            console.log('Remaining time:', minutes, 'minutes', seconds, 'seconds');

            // Actualisation du temps restant chaque seconde
            remainingTime--;

            // Vérification si les 10 minutes sont écoulées
            if (remainingTime < 0) {
              clearInterval(countdownInterval);
              countdownInterval = null; // Réinitialisation de l'ID de l'intervalle
              console.log('Le temps est écoulé – redémarrage du compte à rebours');
            
              // Redémarrage du timer depuis 10 minutes
              Cookies.set('startTime', Math.floor(Date.now() / 1000));
              countdownTimer(); // Relancer la fonction de décompte
            }
          }, 1000);
        } else {
          // Remise à zéro si startTime n'existe pas en cookie
          Cookies.set('startTime', Math.floor(Date.now() / 1000));
          Cookies.remove('lastProductInCartId');
          console.log('Remise à zéro du décompte');
        }
      } else {
        // Suppression de tous les cookies si le panier est vide
        Cookies.remove('lastProductInCartId');
        Cookies.remove('startTime');
        console.log('Le panier est vide. Suppression des cookies');

        // Arrêter le compte à rebours s'il est en cours
        if (countdownInterval) {
          clearInterval(countdownInterval);
          countdownInterval = null;
        }
      }
    },
  });
}


// Vérification si la page est chargée
$(document).ready(function() {
  console.log('La page est chargée');
  countdownTimer();
});

document.addEventListener('click', function(event) {
  // Vérifie si l'élément cliqué est un lien qui commence par /cart
  const target = event.target;
  if (target.tagName === 'A' && target.getAttribute('href').startsWith('/cart')) {
    // Empêche le comportement par défaut du lien
    event.preventDefault();
    openCartDrawer();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  console.log("⏳ DOM loaded. En attente des éléments .kaching-bundles__bar-variant-select...");

  const waitForVariants = setInterval(() => {
    const variantElements = document.querySelectorAll(".kaching-bundles__bar-variant-select");

    if (variantElements.length === 0) {
      console.log("⏳ En attente des éléments .kaching-bundles__bar-variant-select...");
      return;
    }

    clearInterval(waitForVariants);
    console.log(`✅ ${variantElements.length} élément(s) trouvé(s).`);

    if (!window.__OX_OBJECT__ || !window.__OX_OBJECT__.variants_info) {
      console.warn("❌ Données de variantes non trouvées dans window.__OX_OBJECT__.");
      return;
    }

    let changeTimeout = null;
    let lastElementChanged = null;

    const processChange = (element) => {
      const span = element.querySelector("span");
      if (!span) {
        console.warn("❌ Aucun <span> trouvé dans l'élément modifié.");
        return;
      }

      const selectedVariantText = span.textContent.trim();
      console.log("🔍 Variante détectée :", selectedVariantText);

      const selectedVariant = window.__OX_OBJECT__.variants_info.find(variant =>
        variant.title.trim() === selectedVariantText
      );

      if (!selectedVariant) {
        console.warn(`❌ Variante "${selectedVariantText}" non trouvée dans variants_info`);
        return;
      }

      const imageSrc = selectedVariant.featured_image?.src;
      if (!imageSrc) {
        console.warn("❌ Image introuvable pour cette variante.");
        return;
      }

      const fileName = imageSrc.split("/").pop().replace(/\?.*$/, "");
      const mediaPosterValue = `files/${fileName}`;
      console.log(`🎯 media-poster ciblé : ${mediaPosterValue}`);

      const imageDiv = document.querySelector(`div[media-poster="${mediaPosterValue}"]`);
      if (imageDiv) {
        imageDiv.click();
        console.log(`✅ Clic simulé sur l'image avec media-poster="${mediaPosterValue}"`);
      } else {
        console.warn(`❌ Aucune div trouvée avec media-poster="${mediaPosterValue}"`);
      }
    };

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        const changedElement = mutation.target.nodeType === 3 ? mutation.target.parentElement : mutation.target;

        const variantRoot = changedElement.closest(".kaching-bundles__bar-variant-select");
        if (variantRoot) {
          lastElementChanged = variantRoot;
          if (changeTimeout) clearTimeout(changeTimeout);
          changeTimeout = setTimeout(() => {
            processChange(lastElementChanged);
          }, 100);
        }
      }
    });

    variantElements.forEach(el => {
      observer.observe(el, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    });

    console.log("👂 Observation en place pour tous les éléments, avec détection précise du dernier élément réellement modifié.");
  }, 500);
});




document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname !== '/') {
        console.log("🚫 Script désactivé car ce n'est pas la page d'accueil.");
        return;
    }

    console.log("✅ Script activé sur la page d'accueil.");

    const alwaysAllowedProductId = "7659399839951"; // Toujours autorisé
    const urlProductId = new URLSearchParams(window.location.search).get('productId'); // ProductId dans l'URL
    let isTemporarilyDisabled = false;
    let autoClickDone = false;

    function getProductElement(productId) {
        return document.querySelector(`[product-id="${productId}"]`);
    }

    function simulateClickIfNeeded() {
        if (!urlProductId) {
            console.warn("⚠️ Aucun productId dans l'URL.");
            return;
        }

        const productElement = getProductElement(urlProductId);

        if (!productElement) {
            console.warn(`⚠️ Aucun élément avec [product-id="${urlProductId}"] trouvé.`);
            return;
        }

        const gpProductParent = productElement.closest('gp-product');
        if (!gpProductParent) {
            console.warn(`⚠️ Parent <gp-product> non trouvé pour le produit ${urlProductId}.`);
            return;
        }

        const addToCartButton = gpProductParent.querySelector('.addtocartcustom');
        if (!addToCartButton) {
            console.warn("⚠️ Bouton .addtocartcustom introuvable dans le <gp-product>.");
            return;
        }

        console.log("🎯 Clic automatique simulé...");
        isTemporarilyDisabled = true;
        addToCartButton.click();

        setTimeout(() => {
            isTemporarilyDisabled = false;
            autoClickDone = true;
            console.log("✅ Clic auto terminé. Blocage des autres éléments activé.");
        }, 500);
    }

    function clickHandler(event) {
        const clickedElement = event.target;
        const gpProduct = clickedElement.closest('gp-product');

        if (!gpProduct) return;

        const productElement = gpProduct.querySelector('[product-id]');
        if (!productElement) {
            console.warn("⚠️ Aucun attribut [product-id] trouvé.");
            return;
        }

        const productId = productElement.getAttribute('product-id');
        const isAllowed = productId === alwaysAllowedProductId || productId === urlProductId;

        if (isAllowed) {
            if (productId === urlProductId) {
              console.log(`🛑 Produit ${productId} bloqué après clic auto. Déclenchement clic auto .addtocartcustom.`);
              event.preventDefault();
              event.stopPropagation();
          
              const altButton = gpProduct.querySelector('.addtocartcustom');
              if (altButton) {
                  isTemporarilyDisabled = true;
                  altButton.click();
                  setTimeout(() => {
                      isTemporarilyDisabled = false;
                      console.log("🔒 Blocage réactivé après clic simulé sur produit de l'URL.");
                  }, 100);
              }
              return;
            }

            console.log(`✅ Clic autorisé sur le produit ${productId}.`);
            return;
        }

        if (isTemporarilyDisabled) {
            console.log("🚫 Blocage désactivé temporairement (clic auto en cours).");
            return;
        }

        console.log(`🛑 Produit ${productId} bloqué. Annulation du clic.`);
        event.preventDefault();
        event.stopPropagation();

        const altButton = gpProduct.querySelector('.addtocartcustom');
        if (altButton) {
            isTemporarilyDisabled = true;
            altButton.click();
            setTimeout(() => {
                isTemporarilyDisabled = false;
                console.log("🔒 Blocage réactivé après clic simulé.");
            }, 100);
        }
    }

    setTimeout(() => {
        console.log("⏳ 500 ms écoulées. Démarrage des opérations...");
        simulateClickIfNeeded();
        document.addEventListener('click', clickHandler, true);
    }, 500);
});
